const API_URL = process.env.REACT_APP_API_URL || 'https://ceshi.lightark.cc';

export const config = {
  apiUrl: API_URL,
  endpoints: {
    users: {
      me: `${API_URL}/api/v1/users/me`,
      token: `${API_URL}/api/v1/users/token`,
      register: `${API_URL}/api/v1/users/register`,
      defaultWorkspace: (workspaceId: string) => `${API_URL}/api/v1/users/me/default-workspace/${workspaceId}`,
    },
    workspaces: {
      list: `${API_URL}/api/v1/workspaces`,
      create: `${API_URL}/api/v1/workspaces`,
    },
    apps: {
      list: `${API_URL}/api/v1/apps`,
      detail: (appId: string) => `${API_URL}/api/v1/apps/${appId}`,
      create: `${API_URL}/api/v1/apps`,
    },
    versions: {
      list: `${API_URL}/api/v1/versions`,
      detail: (versionId: string) => `${API_URL}/api/v1/versions/${versionId}`,
      create: `${API_URL}/api/v1/versions`,
      delete: (versionId: string) => `${API_URL}/api/v1/versions/${versionId}`,
    },
    runRecords: {
      list: `${API_URL}/api/v1/run-records`,
      delete: (recordId: string) => `${API_URL}/api/v1/run-records/${recordId}`,
    },
    flow: {
      run: `${API_URL}/api/v1/flow/run-flow`,
    },
    generate: `${API_URL}/generate`,
    crewJson: `${API_URL}/crew-json`,
  },
}; 